import React, { useState, useEffect } from "react";

import "./DateTime.css";
import "../Styles/SvgCommand.css";
import SortCommand from "../SortCommand/SortCommand";
import SearchIcon from "../SearchIcon/SearchIcon";
import useSize from "../../../Hooks/useSize.js";
import ReactDOM from "react-dom";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function DateTime(props) {
  const [isDragOver, setDragover] = useState(false);
  const buildStyle = useBuildStyle();

  const getFormat = (value) => {
    return ("0" + value).slice(-2)
  };
  const formatDate = props.data.properties.text.value
  
  
      
  
  const [actualDate, setActualDate] = useState(
    !props.onlyLabel && formatDate != "" ? {...formatDate, currentDate:new Date(JSON.parse(JSON.stringify(formatDate.currentDate)))}  :
      {currentDate: new Date(), currentOption:"d", isCalendarOpen: false,
        day: getFormat(new Date().getDate()), month: getFormat(new Date().getMonth()+1), year:new Date().getFullYear(),
        hour: getFormat(new Date().getHours()), minute: getFormat(new Date().getMinutes()), second: getFormat(new Date().getSeconds())
        , currentPosition: {id:0, y:0}
      } 
  );
  
  const monthLib = [{id:0, value:"January", short:"Janu."},{id:1, value:"February", short:"Febr."},{id:2, value:"March", short:"Marc."}
  ,{id:3, value:"April", short:"Apri."},{id:4, value:"May", short:"May"},{id:5, value:"June", short:"June"},
  {id:6, value:"July", short:"July"},{id:7, value:"August", short:"Augu."},{id:8, value:"September", short:"Sept."}
  ,{id:9, value:"October", short:"Octo."},{id:10, value:"November", short:"Nove."},{id:11, value:"December", short:"Dece."}];
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const inf = "<";
  const sup = ">";
  const days = [{id:0, value:"su"},{id:0, value:"mo"},{id:0, value:"tu"},{id:0, value:"we"}
  ,{id:0, value:"th"},{id:0, value:"fr"},{id:0, value:"sa"}];
  
  var newDate = new Date(JSON.parse(JSON.stringify(actualDate.currentDate)));
  const getMonth = () =>{
    return monthLib.filter(item => item.id == actualDate.currentDate.getMonth()).map(item=> item.value)[0];
  }
  useEffect(() => {
  
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const onSelectMonth = (monthNumber) =>  {
    
    newDate.setMonth(monthNumber);
    
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = newDate;
    newValue["currentOption"] = "d";
    newValue["month"] = getFormat(newDate.getMonth()+1);
    //newValue["isCalendarOpen"] = false
    setActualDate(newValue);
  }

  const onSelectYear = (yearNumber) =>  {
    newDate.setYear(yearNumber);
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = newDate;
    newValue["currentOption"] = "m";
    newValue["year"] = newDate.getFullYear();
    //newValue["isCalendarOpen"] = false
    setActualDate(newValue);
  }

  const onSelectDay = (e, dateNumber) =>  {
    newDate.setDate(dateNumber);
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = newDate;
    newValue["day"] = getFormat(newDate.getDate());
    newValue["isCalendarOpen"] = false
    setActualDate(newValue);
    e.stopPropagation()
    props.onChange(e, newValue)
  }

  const onClickDay = () =>  {
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = actualDate.currentDate;
    newValue["currentOption"] = "d";
    setActualDate(newValue);
  }

  const onClickMonth = () =>  {
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = actualDate.currentDate;
    newValue["currentOption"] = "m";
    setActualDate(newValue);
  }
  
  const onClickYear = () =>  {
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = actualDate.currentDate;
    newValue["currentOption"] = "y";
    setActualDate(newValue);
  }
 
  const onClickNext = () => {
    var newValue = JSON.parse(JSON.stringify(actualDate));
    switch (actualDate.currentOption) {
      case "d":
        newDate.setMonth(actualDate.currentDate.getMonth()+1);
        newValue["currentDate"] = newDate;
        newValue["day"] = getFormat(newDate.getDate());
        newValue["month"] = getFormat(newDate.getMonth()+1);
        newValue["year"] = newDate.getFullYear();
        setActualDate(newValue)
    
        break;
      case "m":
        newDate.setYear(actualDate.currentDate.getFullYear()+1);
        newValue["currentDate"] = newDate;
        newValue["day"] = getFormat(newDate.getDate());
        newValue["month"] = getFormat(newDate.getMonth()+1);
        newValue["year"] = newDate.getFullYear();
        setActualDate(newValue)
        
        break;
      case "y":
        newDate.setYear(actualDate.currentDate.getFullYear()+12);
        newValue["currentDate"] = newDate;
        newValue["day"] = getFormat(newDate.getDate());
        newValue["month"] = getFormat(newDate.getMonth()+1);
        newValue["year"] = newDate.getFullYear();
        setActualDate(newValue)
        
        break;
    }  
  }

  const getFirst =()=> {
    switch (actualDate.currentOption) {
      case "d":
        return titleMonth();
      case "m":
        return titleDay();
      case "y":
        return titleDay()
    }  
  }

  const getSecond =()=> {
    switch (actualDate.currentOption) {
      case "d":
        return titleYear();
      case "m":
        return titleYear();
      case "y":
        return titleMonth();
    }  
  }

  const onClickPrevious = () => {
    var newValue = JSON.parse(JSON.stringify(actualDate));
    switch (actualDate.currentOption) {
      case "d":
        newDate.setMonth(actualDate.currentDate.getMonth()-1);
        newValue["currentDate"] = newDate;
        newValue["day"] = getFormat(newDate.getDate());
        newValue["month"] = getFormat(newDate.getMonth()+1);
        newValue["year"] = newDate.getFullYear();
        setActualDate(newValue)
        
        break;
      case "m":
        newDate.setYear(actualDate.currentDate.getFullYear()-1);
        newValue["currentDate"] = newDate;
        newValue["day"] = getFormat(newDate.getDate());
        newValue["month"] = getFormat(newDate.getMonth()+1);
        newValue["year"] = newDate.getFullYear();
        setActualDate(newValue)
        
        break;
      case "y":
        newDate.setYear(actualDate.currentDate.getFullYear()-12);
        newValue["currentDate"] = newDate;
        newValue["day"] = getFormat(newDate.getDate());
        newValue["month"] = getFormat(newDate.getMonth()+1);
        newValue["year"] = newDate.getFullYear();
        setActualDate(newValue)
        
        break;
    }  

  }

  const getInputWidth = () => {
    var inputWidth = props.style.width.value;
    const iconWidth = 13;
    if (props.sortable) {
      
      inputWidth = parseInt(inputWidth.slice(0, -2)) - iconWidth + "px";
    }
       
    if (props.filterable) {
      inputWidth = parseInt(inputWidth.slice(0, -2)) - iconWidth + "px";
    }

    return inputWidth;
  };
  
  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    
    newStyle["border"] = isDragOver ? "1px dashed #1f79e1" : 
      props.errors ? props.errors.border : props.style.border.value;
    return newStyle;
  };

  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };


  const onChangeValue = (e, type) => {
    
    var newValue = JSON.parse(JSON.stringify(actualDate));
    newValue["currentDate"] = actualDate.currentDate;
    newValue[type] = e.target.value;
    setActualDate(newValue);
  };
 
  
 const changeCurrentDate = (e) => {
    
    var canUpdate = actualDate.year != actualDate.currentDate.getFullYear() 
    || parseInt(actualDate.month) != actualDate.currentDate.getMonth() + 1
    || parseInt(actualDate.day) != actualDate.currentDate.getDate()
    || parseInt(actualDate.hour) != actualDate.currentDate.getHours()
    || parseInt(actualDate.minute) != actualDate.currentDate.getMinutes()
    || parseInt(actualDate.second) != actualDate.currentDate.getSeconds();
    var newValue = JSON.parse(JSON.stringify(actualDate));

    if(canUpdate) {
      var value = new Date(actualDate.year + "-" + actualDate.month + "-" + actualDate.day + " "+ actualDate.hour +":"+ actualDate.minute +":"+ actualDate.second);
      var isValidDate = !isNaN(value.getFullYear()) && !isNaN(value.getMonth()) && !isNaN(value.getDate());

      if (isValidDate){
        newValue["currentDate"] = value;
        newValue["day"] = getFormat(value.getDate());
        newValue["month"] = getFormat(value.getMonth()+1);
        newValue["year"] = value.getFullYear();
        newValue["hour"] = getFormat(value.getHours());
        newValue["minute"] = getFormat(value.getMinutes());
        newValue["second"] = getFormat(value.getSeconds());
        setActualDate(newValue);
        
      }
      else{
        newValue["currentDate"] = actualDate.currentDate;
        newValue["day"] = getFormat(actualDate.currentDate.getDate());
        newValue["month"] = getFormat(actualDate.currentDate.getMonth()+1);
        newValue["year"] = actualDate.currentDate.getFullYear();
        newValue["hour"] = getFormat(actualDate.currentDate.getHours());
        newValue["minute"] = getFormat(actualDate.currentDate.getMinutes());
        newValue["second"] = getFormat(actualDate.currentDate.getSeconds());
      
        setActualDate(newValue);
        
      }
    }
  };

  const getItemDate = (type) => {
    switch (type) {
      case "dd":
        
        return (
          <div>
            <input value={formatDate.day ? formatDate.day : ""} 
              onChange={(e) => onChangeValue(e,"day")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="day"
              maxLength="2"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "mm":
        return (
          <div>
            <input  value={formatDate.month ? formatDate.month : ""}
              onChange={(e) => onChangeValue(e,"month")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="month"
              maxLength="2"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "yyyy":
        return (
          <div>
            <input value={formatDate.year ? formatDate.year : ""}
              onChange={(e) => onChangeValue(e,"year")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "36px",
                margin: "0px",
              }}
              type="text"
              name="year"
              maxLength="4"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "hh":
        return (
          <div>
            <input value={formatDate.hour ? formatDate.hour : ""}
              onChange={(e) => onChangeValue(e, "hour")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="hour"
              maxLength="2"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "mn":
        return (
          <div>
            <input value={actualDate.minute}
              onChange={(e) => onChangeValue(e, "minute")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="hour"
              maxLength="2"
              className="input inputOnlyBottomBorder"
              />
            </div>
          );
      case "ss":
        return (
          <div>
            <input value={actualDate.second}
              onChange={(e) => onChangeValue(e, "second")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="hour"
              maxLength="2"
              className="input inputOnlyBottomBorder"
              />
            </div>
          );
      default:
        throw new Error();
    }
  };

  const getItemTime = (type) => {
    
    switch (type) {
      case "dd":
        return (
          <div>
            <input value={formatDate.day ? formatDate.day : ""}
              onChange={(e) => onChangeValue(e,"day")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="day"
              maxLength="2"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "mm":
        return (
          <div>
            <input  value={formatDate.month ? formatDate.month : ""}
              onChange={(e) => onChangeValue(e,"month")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="month"
              maxLength="2"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "yyyy":
        return (
          <div>
            <input value={formatDate.year ? formatDate.year : ""}
              onChange={(e) => onChangeValue(e,"year")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "36px",
                margin: "0px",
              }}
              type="text"
              name="year"
              maxLength="4"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "hh":
        return (
          <div>
            <input value={formatDate.hour ? formatDate.hour : ""}
              onChange={(e) => onChangeValue(e, "hour")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="hour"
              maxLength="2"
              className="input inputOnlyBottomBorder"
            />
          </div>
        );
      case "mn":
        return (
          <div>
            <input value={formatDate.minute ? formatDate.minute : ""}
              onChange={(e) => onChangeValue(e, "minute")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="hour"
              maxLength="2"
              className="input inputOnlyBottomBorder"
              />
            </div>
          );
      case "ss":
        return (
          <div>
            <input value={formatDate.second ? formatDate.second : ""}
              onChange={(e) => onChangeValue(e, "second")}
              onMouseLeave={(e) => changeCurrentDate(e)}
              style={{
                width: "20px",
                margin: "0px",
              }}
              type="text"
              name="hour"
              maxLength="2"
              className="input inputOnlyBottomBorder"
              />
            </div>
          );
      default:
        throw new Error();
    }
  };
 
  
  const getCalendarData = () => {
    
    var calendars = [...(new Array(42))];
    var firstDate = new Date(actualDate.currentDate.getFullYear(), actualDate.currentDate.getMonth(), 1);
    
    var data =[[],[],[],[],[],[]];
    var becauseOfStartSunday = 1;
    var dayPosition = firstDate.getDay() + becauseOfStartSunday;
    var lastPreviousDate = new Date(firstDate.setDate(firstDate.getDate()-dayPosition));
    
    calendars.map((_,index)=> data[getPosition(index)].push(getNextDate(lastPreviousDate)));
    return data;
  }

  const getPosition = (index) => {
    var numCol = 7;
    return Math.floor(index / numCol) ;
  }

  const getNextDate = (nextDate) => {
    var dayOfMonth = new Date(nextDate.setDate(nextDate.getDate()+1))
    var isCurrent = actualDate.currentDate.getMonth() == dayOfMonth.getMonth();
   
    return {isCurrent: isCurrent, value: dayOfMonth.getDate() };
  }

  const day = () => {
    return (
    <React.Fragment>
      <div style = {{display:"flex"}}>
        {days.map((item, index) => 
          <div key={index} className="calendarHeader">
            <span>{item.value}</span>
          </div>
        )} 
        
      </div>
      {[...(new Array(6))].map((_, i) => 
      <div key={i} style = {{display:"flex"}}>
        {[...(new Array(7))].map((_, j) => 
          <div key={i +""+ j} style = {{color: (j==0 || j==6)  ? "#d7191c" : calendarData[i][j].isCurrent ? "rgba(73, 80, 87)" : "#cccccc",
            border: newDate.getFullYear() ==  new Date().getFullYear() 
            && newDate.getMonth() ==  new Date().getMonth() 
            && calendarData[i][j].value ==  new Date().getDate() 
            ? "1px solid blue" : "none" }} 
            className ="day" onClick={(e)=> onSelectDay(e, calendarData[i][j].value)}>
              <div>{calendarData[i][j].value}</div> 
              
          </div>
        )} 
      </div>
      
    )}
    </React.Fragment>
    )
  }

  const month = () => {
    return  [...(new Array(3))].map((_, i) => 
      <div style = {{display:"flex"}}>
        {[...(new Array(4))].map((_, j) =>  
          <div style = {{color: "#212121",
            border: i*4+j ==  new Date().getMonth() ? "1px solid blue" : "none" }} 
            className ="month" onClick={()=> onSelectMonth(i*4+j)}>
            <div>{monthLib[i*4+j].short}</div> 
          </div>
        )}
      </div>
    )
  }

  const year = () => {
    return  [...(new Array(3))].map((_, i) => 
    <div style = {{display:"flex"}}>
      {[...(new Array(4))].map((_, j) =>  
        <div style = {{color: "#212121",border: actualDate.currentDate.getFullYear() + (i*4+j) ==  new Date().getFullYear() ? "1px solid blue" : "none"  }} 
        className ="month" onClick={()=> onSelectYear(actualDate.currentDate.getFullYear() + (i*4+j))} >
          <div>{actualDate.currentDate.getFullYear() + (i*4+j)}</div> 
        </div>
      )}
    </div>
  )
  }

  const getCurrentComponent = () => 
  {
    switch (actualDate.currentOption) {
      case "d":
        return day();
      case "m":
        return month();
      case "y":
        return year();
    }  
  }

  const titleDay = () => {   
    return <span onClick={() => onClickDay()}>{actualDate.day}</span>
   }

  const titleMonth = () => {   
   return <span onClick={() => onClickMonth()}>{getMonth()}</span>
  }

  const titleYear = () => {   
    return <span onClick={() => onClickYear()}>{actualDate.currentDate.getFullYear()}</span>
   }

  const updateCalenDar =(e, value) => {
    var currentMousePosition = {};
    var newValue = JSON.parse(JSON.stringify(actualDate));
   
    currentMousePosition["x"] = window.scrollX + e.clientX ; //parseInt(e.target.scrollLeft) + e.clientX;
    currentMousePosition["y"] = window.scrollY + e.clientY + 10; //parseInt(e.target.scrollTop) + e.clientY + 10;
    if(value !== actualDate.isCalendarOpen){
      newValue["currentDate"] = actualDate.currentDate;
      newValue["currentOption"] = "d";
      newValue["currentPosition"] = currentMousePosition;
      newValue["isCalendarOpen"] = value;
      setActualDate(newValue);
      
    }
      
  }

  const getDateComponent=() => {
      var positions = props.data.properties.dateFormat.value.split("/");
      
      return <React.Fragment>
        {getItemDate(positions[0])}
        <div
          style={{
            width: "7px",
            color: "#cccccc",
            userSelect: "none",
            fontSize: 14,
          }}
        >
          /
        </div> 
        {getItemDate(positions[1])}
        <div
          style={{
            width: "7px",
            color: "#cccccc",
            userSelect: "none",
            fontSize: 14,
          }}
        >
          /
        </div> 
        {getItemDate(positions[2])}
      </React.Fragment>
  }

  const getTimeComponent=() => {
    var positions = props.data.properties.timeFormat.value.replace("mm","mn").split(":");
    
    return <React.Fragment>
      <div
          style={{
            width: "7px",
            color: "#cccccc",
            userSelect: "none",
            fontSize: 14,
          }}
        >
          
        </div> 
        {getItemTime(positions[0]) }
        {positions[1] &&  <div
          style={{
            width: "4px",
            color: "#cccccc",
            userSelect: "none",
            fontSize: 14,
          }}
        >
        :
        </div>
        }
        {positions[1] && getItemTime(positions[1])}
        {positions[2] && <div
          style={{
            width: "4px",
            color: "#cccccc",
            userSelect: "none",
            fontSize: 14,
          }}
        >
        :
        </div>
        }
        {positions[2] && getItemTime(positions[2])}
    </React.Fragment>
}

  const getDate = () => {
    
    return (
      <React.Fragment>
        <div
          draggable={props.draggable}
          onDragStart={(e) => props.onDragStart(e)}
          onClick={props.onClick}
          style={{...buildStyle(props.style), width:getInputWidth()}} //props.style
          id={props.data.id}
          onMouseDown={(e) => props.data.properties.date.value  && updateCalenDar(e, true)}
          onMouseLeave={(e) => props.data.properties.date.value  && updateCalenDar(e, false)}>
          {props.data.properties.date.value  && getDateComponent()}
          {props.data.properties.time.value  && getTimeComponent()}
          {getCalenDar()}
        </div>
        <div style={{paddingTop: "5px" }}>
          {props.filterable && <SearchIcon className= "svgSearchIcon" onClick = {(e) => props.onClickSearchIcon(e)} id = {"Filter" + props.data.id} width="13px" />}
        </div>
        {props.errors && !props.errors.isColumn &&  <input readOnly style={props.errors.styles} value={props.errors.value} />}
   </React.Fragment>
    );
  };

  const getCalenDar = () => {
    
    var x = actualDate.currentPosition.x;
    var y = actualDate.currentPosition.y;
    
    return (
      actualDate.isCalendarOpen ? ReactDOM.createPortal( //position:"fixed"
        <div className="calendarContainer" style={{left:x, top:y, position:"absolute", zIndex:2000}}> 
          <div className="calendar">
            <div onClick={() => onClickPrevious()} >{inf}</div>
            <div >
              {getFirst()}
              <span> , </span>
              {getSecond()}
            </div>
          <div onClick={() => onClickNext()}>{sup}</div>
        </div>
          <div>
            {getCurrentComponent()}
          </div>
        </div>,
         document.body
      ): null
       
    );
  };
  var calendarData =  getCalendarData();

  return  props.onlyLabel ? (
     
    <div
      draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      onDrop={(e) => props.onlyLabel && onDropColumn(e)}
      onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
      onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
      onClick={props.onClick}
      style={getStyle()}
      id={props.data.id}
    >
      <div
        className="label"
        style={{
          position: "relative",
          width: getInputWidth(),
          display: "flex",
          userSelect: "none",
          fontSize: props.style.fontSize,
        }}
      >
        {props.data.properties.text.value}
       
        
      </div>
      
     <div style={{paddingTop: "5px"}}>
      {props.sortable && <SortCommand />}
    </div>
    </div>
  
  ) : (
    getDate()
    
  )
 
 
}
